<template>
  <div class="app-page satisfaction">
      <vue-headful title="ALICE | Satisfaction"></vue-headful>
      <div class="satisfaction-wrapper">
          <div v-if="!isPageLoading">
            <div class="row head-row">
                <div class="col">
                  <div class="head-title">
                    <span class="icon">
                        <font-awesome-icon icon="star-half-alt"></font-awesome-icon>
                    </span>
                    <span>Ratings and Reviews</span>
                    <!-- <div class="head-subtitle ml-1">
                      <span>| Based on {{ satisfactionSummaryData.surveyed }} ratings</span>
                    </div> -->
                  </div>
                </div>
            </div>

            <div class="row reviews-filter">
              <div class="reviews-filter-left">
                <div class="form-row">
                  <div class="col filter-row mb-1">
                    <span class="filter-title reviews-filter-left-text mr-2">Date: </span>
                    <div class="select mr-1" @change="toggleDateMode">
                      <select v-model="dateMode">
                        <option value="">All time</option>
                        <option value="last7day">Last 7 days</option>
                        <option value="last30day">Last 30 days</option>
                        <option value="custom">Custom</option>
                      </select>
                    </div>
                    <date-range-picker
                        v-if="dateMode === 'custom'"
                        v-model="dateRange"
                        :ranges="false"
                        :show-dropdowns="true"
                        :maxDate="maxDate"
                        :date-format="dateFormat"
                        opens="right"
                        @start-selection="setStartDateSelection"
                        @finish-selection="setEndDateSelection"
                        @toggle="onCalendarToggle">
                          <div slot="input">
                            {{ formatDate(this.dateRange.startDate) }} - {{ formatDate(this.dateRange.endDate) }}
                          </div>
                    </date-range-picker>

                    <span class="filter-title reviews-filter-left-text ml-3 mr-2">Filter by:</span>
                    <div class="select mr-1">
                        <select v-model="selectedScoreOptions" @change="toggleFilter">
                          <option v-for="star in starOptions" :key="star.value" :value="star.value">
                              {{ star.name }}
                          </option>
                        </select>
                    </div>
                    <div class="select mr-1">
                        <select v-model="selectedChannelOptions" @change="toggleFilter">
                            <option value="">Channel</option>
                            <option v-for="(channel, idx) in channelStat" :key="idx" :value="channel">
                                {{ channel }}
                            </option>
                          </select>
                    </div>
                    <div class="select mr-1">
                        <select v-model="selectedLanguage" @change="toggleFilter">
                          <option v-for="lang in languageOptions" :key="lang.value" :value="lang.value">
                              {{ lang.name }}
                          </option>
                        </select>
                    </div>
                  </div>
                </div>
              </div>

              <div class="reviews-filter-right">
                <div class="row reviews-filter-right-export">
                  <div class="form-inline">
                      <div class="form-group mb-2 mr-1">
                        <input type="text" class="form-control" placeholder="Search User" v-model="userSearchInput"  @input="toggleUserSearchInput">
                      </div>
                      <button class="btn btn-primary mb-2" @click="exportFormWithFilter" :disabled="satisfactionFormWithFilterData && satisfactionFormWithFilterData.content && !satisfactionFormWithFilterData.content.length">
                        <i class="fas fa-download mr-1"></i> Export
                      </button>
                      <b-loading :is-full-page="true" :active.sync="isExportLoading" :can-cancel="false"></b-loading>
                    </div>
                </div>
              </div>
            </div>

            <div class="row ratings">
                <div class="col-sm-12 col-xl-6">
                    <div class="card stat-card">
                        <div class="card-header mb-3">SUMMARY</div>
                        <div class="card-body d-flex flex-column align-items-center">
                            <div class="ratings-averages mb-2">
                              <span v-if="summaryData && summaryData.average_score">
                                <span class="ratings-averages-display mr-1">
                                  {{ summaryData.average_score.toFixed(2) }}
                                </span>
                                out of {{ maxRating }}
                              </span>
                              <h2 v-else class="mr-1">No rating</h2>
                            </div>
                            <div class="ratings-star mb-3">
                                <span class="badge badge-pill badge-light">
                                    <b-rate
                                        v-model="summaryData.average_score"
                                        :max="maxRating"
                                        :size="sizes"
                                        :icon-pack="packs"
                                        :icon="icons"
                                        :spaced="isSpaced"
                                        :disabled="isDisabled">
                                    </b-rate>
                                </span>
                            </div>
                            <div class="total-user mb-2">
                                <i class="fas fa-user-alt mr-1"></i>
                                <span>{{ summaryData.total || 0}} Total</span>
                            </div>
                            <div class="user-rated mb-2">
                                <span>Rated {{ summaryData.surveyed  || 0}} | Unrated {{ summaryData.unsurveyed }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-xl-6">
                    <div class="card stat-card">
                        <!-- <div class="custom-card-bar-header"></div> -->
                        <div class="card-header mb-3">ALL TIME RATING</div>
                        <div class="card-body d-flex flex-column mb-1">
                            <div class="row ratings-bar-body mb-2" v-for="[key, value] of Object.entries(surveyedStat)" :key="key">
                                <div class="ratings-bar-display-name col-sm-2 col-md-2">{{ key }}</div>
                                <div class="col-sm-8 col-md-8 pt-1">
                                    <b-progress :value="((value / summaryData.surveyed) * 100 ) || 0" show-value format="percent" type="is-success"></b-progress>
                                </div>
                                <div class="ratings-bar-display-count col-sm-2 col-md-2">
                                    {{ value }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row head-reviews">
              <div class="col">
                  <div class="head-reviews-title">
                     <span>Total reviews</span>
                      <!-- <span><span v-if="satisfactionSummaryData && satisfactionSummaryData.surveyed">{{ satisfactionSummaryData.surveyed }}</span> Ratings </span> -->
                  </div>
              </div>
            </div>

          <div class="reviews-wrapper">
            <div class="reviews" v-if="satisfactionFormWithFilterData && satisfactionFormWithFilterData.content && satisfactionFormWithFilterData.content.length">
              <div class="row">
                <div class="col-sm-12 col-xl-3" v-for="content of satisfactionFormWithFilterData.content" :key="content.id">
                  <div class="card card-reviews">
                    <div class="">
                      <div class="card-content d-flex flex-column p-3">
                          <div class="ratings-star mb-1">
                              <b-rate
                                  v-model="content.score"
                                  :max="maxRating"
                                  size="`is-small`"
                                  :icon-pack="packs"
                                  :icon="icons"
                                  :spaced="isSpaced"
                                  :disabled="isDisabled">
                              </b-rate>
                          </div>
                          <div class="user-info mb-2">
                              <span>{{content.username}} , {{ convertDate(content.created_at) }}</span>
                          </div>
                          <!-- <div class="preset-comments mb-2" v-if="mockPreset && mockPreset.length">
                            <div class="preset-comment" v-for="(preset,idx) in mockPreset" :key="idx">
                              {{ preset }}
                            </div>
                          </div> -->
                          <div class="preset-comments mb-2" v-if="content.preset_comment && content.preset_comment.length">
                            <div class="preset-comment" v-for="(preset,idx) in content.preset_comment" :key="idx">
                              {{ preset }}
                            </div>
                          </div>
                          <div class="line-clamp mt-2">
                              <span class="text-comment"> {{ content.comment }} </span>
                          </div>
                      </div>
                    </div>
                    <!-- <div class="card-reviews-footer text-muted">
                      <span class="ml-2"> {{ mapChannelName(content.channel) }} </span>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>

            <div v-else class="reviews-not-found">
              <div class="row reviews-not-found-text">
                  <font-awesome-icon icon="search"></font-awesome-icon> <span class="ml-1"> No data found </span>
              </div>
            </div>
          </div>

          <div class="row footer-pagination" v-if="satisfactionFormWithFilterData.content && satisfactionFormWithFilterData.content.length">
              <div class="footer">
                  <bootstrap-pagination
                      v-model="currentPage"
                      :total-rows="satisfactionFormWithFilterData.totalElements"
                      :per-page="perPage"
                      align="left"
                      size="sm"
                      first-text="First"
                      prev-text="Prev"
                      next-text="Next"
                      last-text="Last"
                      @change="togglePage"
                  ></bootstrap-pagination>
              </div>
              <!-- <bootstrap-pagination
                  v-model="currentPage"
                  :total-rows="satisfactionFormWithFilterData.totalElements"
                  :per-page="perPage"
                  align="left"
                  size="sm"
                  first-text="First"
                  prev-text="Prev"
                  next-text="Next"
                  last-text="Last"
                  @change="togglePage"
              ></bootstrap-pagination> -->
          </div>
          </div>
      </div>
      <div id="download-area"></div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import { BPagination } from 'bootstrap-vue';
import moment from 'moment';
import { debounce } from 'underscore';
import alice from '../alice-api';
// import Pagination from 'vue-pagination-2';
// import RatingWidget from '../components/DashboardWidgets/RatingWidget.vue';
// import { BFormRating } from 'bootstrap-vue';

export default {
  name: 'satisfaction',
  components: {
    'bootstrap-pagination': BPagination,
    // Pagination,
    // 'rating-wedget': RatingWidget,
    // 'b-form-rating': BFormRating,
  },
  data() {
    return {
      // maxDate: moment().toISOString(),
      // dateRange: {
      //   startDate: moment().subtract(7, 'day').startOf('day').toISOString(),
      //   endDate: moment().endOf('day').toISOString(),
      // },
      maxDate: null,
      originStartDate: moment().subtract(7, 'day').startOf('day'),
      originEndDate: moment().endOf('day'),
      isSelectedStartDate: false,
      isSelectedEndDate: false,
      selectedStartDate: null,
      selectedEndDate: null,
      dateRange: {
        startDate: null,
        endDate: null,
      },

      userSearchInput: '',
      selectedScoreOptions: '', // score
      starOptions: [
        { name: 'Overall rating', value: '' },
        { name: 'Excellent (5)', value: 5 },
        { name: 'Good (4)', value: 4 },
        { name: 'Fair (3)', value: 3 },
        { name: 'Poor (2)', value: 2 },
        { name: 'Very poor (1)', value: 1 },
      ],
      languageOptions: [
        { name: 'Language', value: '' },
        { name: 'Thai', value: 'TH' },
        { name: 'English', value: 'EN' },
      ],
      selectedChannelOptions: '', // channel
      selectedLanguage: '',
      channelOptions: [
        { name: 'Channel', value: '' },
        { name: 'Smart HR Application', value: 'ada' },
        { name: 'Microsoft Teams', value: 'msteams' },
      ],
      isOnlySurvey: true,
      isOnlySurveySummaryWithFilter: false,

      summaryWithFilter: [],
      dateMode: '',
      channel: [],

      // b-rate
      maxRating: 5,
      sizes: 'is-medium',
      packs: 'fa',
      icons: 'star',
      isSpaced: true,
      isDisabled: true,

      // pagination
      currentPageFilter: 0, // for get API
      currentPage: 1,
      perPage: 12,

      isLoading: true,
      isPageLoading: true,
      isExportLoading: false,
    };
  },
  created() {
    // we do this to prevent ui bug
    this.maxDate = moment(this.originStartDate).add(7, 'd').add(1, 'M').toISOString();

    this.selectedStartDate = this.originStartDate.toISOString();
    this.selectedEndDate = this.originEndDate.toISOString();

    this.dateRange.startDate = this.originStartDate.toISOString();
    this.dateRange.endDate = this.originEndDate.toISOString();
  },
  async mounted() {
    this.toggleDateMode();
    this.isPageLoading = false;
  },
  methods: {
    ...mapActions({
      getSatisfactionForm: 'satisfaction/getSatisfactionForm',
      getSatisfactionSummary: 'satisfaction/getSatisfactionSummary',
      loadSatisfactionWithFilter: 'satisfaction/loadSatisfactionWithFilter',
      createFormSatisfaction: 'satisfaction/createFormSatisfaction',
      exportSatisfactionForm: 'satisfaction/exportSatisfactionForm',
    }),
    toggleDateMode() {
      if (this.dateMode) {
        const mode = this.dateMode;
        if (mode === 'today') {
          const now = moment();
          this.dateRange.endDate = now.toISOString();
          this.dateRange.startDate = now.startOf('day').toISOString();
          this.toggleFilter();
        } else if (mode === 'last7day') {
          this.initDateInput(6);
        } else if (mode === 'last30day') {
          this.initDateInput(29);
        } else if (mode === 'custom') {
          this.initDateInput(59);
        }
      } else {
        this.initFilter();
      }
    },
    initDateInput(number) {
      if (number) {
        const now = moment();
        this.dateRange.endDate = now.toISOString();
        this.dateRange.startDate = now
          .subtract(number, 'days')
          .startOf('day')
          .toISOString();
      }
      this.toggleFilter();
    },
    async exportFormWithFilter() {
      this.isExportLoading = true;
      const filter = [];
      if (this.selectedScoreOptions) {
        filter.push({
          field: 'score',
          value: [
            this.selectedScoreOptions,
          ],
        });
      }
      if (this.userSearchInput && this.userSearchInput.trim().length > 0) {
        filter.push({
          field: 'username',
          value: [
            this.userSearchInput,
          ],
        });
      }

      let dateFilter = {};
      if (this.dateMode) {
        dateFilter = {
          from: this.dateRange.startDate,
          to: this.dateRange.endDate,
        };
      }

      await alice.exportSatisfactionForm({
        filter,
        dateFilter,
        onlySurvey: true,
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          const elem = document.getElementById('download-area');
          const fileName = response.headers['x-file-name'];
          link.href = url;
          link.setAttribute('download', fileName);
          elem.innerHTML = '';
          elem.appendChild(link);
          link.click();
          this.isExportLoading = false;
        })
        .catch(() => {
          this.isExportLoading = false;
          this.$buefy.toast.open({
            type: 'is-danger',
            message: 'An error occurred, Cannot export data.',
            position: 'is-bottom',
          });
        });
    },
    convertDate(dateStr) {
      return moment(dateStr).format('DD/MM/YYYY');
    },
    formatDate(str) {
      return moment(str).format('ll');
    },
    mapChannelName(channel) {
      const channelName = {
        ada: {
          name: 'Smart HR',
        },
        msteams: {
          name: 'Microsoft Teams',
        },
      };
      return channelName[channel] ? channelName[channel].name : channel;
    },
    // async toggleDateRange() {
    //   this.currentPageFilter = 0;
    //   await this.getSatisfactionWithFilter();
    // },
    // async toggleScore() {
    //   this.currentPageFilter = 0;
    //   await this.getSatisfactionWithFilter();
    // },
    // async toggleSurvey() {
    //   this.currentPageFilter = 0;
    //   await this.getSatisfactionWithFilter();
    // },
    toggleUserSearchInput: debounce(function () {
      this.currentPageFilter = 0;
      this.initFilter();
    }, 800),
    togglePage(page) {
      this.currentPageFilter = page - 1;
      this.initFilter();
    },
    toggleFilter() {
      if (this.isSelectedStartDate && this.isSelectedEndDate) {
        if (this.selectedEndDate < this.selectedStartDate) {
          this.dateRange.startDate = this.selectedEndDate;
          this.dateRange.endDate = this.selectedStartDate;
        } else {
          this.dateRange.startDate = this.selectedStartDate;
          this.dateRange.endDate = this.selectedEndDate;
        }
      }

      this.isSelectedStartDate = false;
      this.isSelectedEndDate = false;
      this.selectedStartDate = this.originStartDate.toISOString();
      this.selectedEndDate = this.originEndDate.toISOString();

      // filter by daterange, score
      this.currentPageFilter = 0;
      this.initFilter();
    },
    async initFilter() {
      this.isLoading = true;
      const filter = [];
      if (this.selectedScoreOptions) {
        filter.push({
          field: 'score',
          value: [
            this.selectedScoreOptions,
          ],
        });
      }
      if (this.selectedChannelOptions) {
        filter.push({
          field: 'channel',
          value: [
            this.selectedChannelOptions,
          ],
        });
      }
      if (this.selectedLanguage) {
        filter.push({
          field: 'language',
          value: [
            this.selectedLanguage,
          ],
        });
      }
      if (this.userSearchInput && this.userSearchInput.trim().length > 0) {
        filter.push({
          field: 'username',
          value: [
            this.userSearchInput,
          ],
        });
      }

      await this.getSummaryWithFilter(filter);
      await this.getSatisfactionWithFilter(filter);
      this.setChannel();
      this.isLoading = false;
    },
    async getSummaryWithFilter(filter) {
      let result = null;
      if (this.dateMode) {
        result = await alice.getFormSummaryWithFilter({
          filter,
          dateFilter: {
            from: moment(this.dateRange.startDate).utcOffset(420).startOf('day'),
            to: moment(this.dateRange.endDate).utcOffset(420).endOf('day'),
          },
          size: 12,
          page: this.currentPageFilter,
          sortBy: 'created_at',
          sortDirection: 'ASC',
          onlySurvey: this.isOnlySurveySummaryWithFilter,
        });
      } else {
        // result = await alice.getFormSummaryWithFilter();
        result = await alice.getFormSummaryWithFilter({
          filter,
          dateFilter: {},
          size: 12,
          page: this.currentPageFilter,
          sortBy: 'created_at',
          sortDirection: 'ASC',
          onlySurvey: this.isOnlySurveySummaryWithFilter,
        });
      }

      if (result && result.data && result.data.data) {
        const { data } = result.data;
        this.summaryWithFilter = data;
      }
    },
    async getSatisfactionWithFilter(filter) {
      if (this.dateMode) {
        await this.loadSatisfactionWithFilter({
          searchBody: {
            filter,
            dateFilter: {
              from: moment(this.dateRange.startDate).utcOffset(420).startOf('day'),
              to: moment(this.dateRange.endDate).utcOffset(420).endOf('day'),
            },
            size: 12,
            page: this.currentPageFilter,
            sortBy: 'created_at',
            sortDirection: 'DESC',
            onlySurvey: this.isOnlySurvey,
          },
        });
      } else {
        // await this.loadSatisfactionWithFilter({
        //   searchBody: {},
        // });
        await this.loadSatisfactionWithFilter({
          searchBody: {
            filter,
            dateFilter: {},
            size: 12,
            page: this.currentPageFilter,
            sortBy: 'created_at',
            sortDirection: 'DESC',
            onlySurvey: this.isOnlySurvey,
          },
        });
      }
    },
    setChannel() {
      const channelFromSummary = Object.keys(this.summaryWithFilter.channel_stat); // after getSummaryWithFilter

      if (this.channel && this.channel.length) {
        // Check exist channel
        const found = this.channel.some((c) => channelFromSummary.includes(c));

        if (!found && channelFromSummary && channelFromSummary.length) {
          for (const newChannel of channelFromSummary) {
            this.channel.push(newChannel);
          }
        }
      } else {
        // first load
        this.channel = channelFromSummary;
      }
    },

    onCalendarToggle(isCalendarOpen) {
      if (isCalendarOpen === false) {
        if (this.isSelectedStartDate && this.isSelectedEndDate) {
          this.toggleFilter();
        } else {
          this.isSelectedStartDate = false;
          this.isSelectedEndDate = false;
          this.selectedStartDate = this.originStartDate.toISOString();
          this.selectedEndDate = this.originEndDate.toISOString();
        }
      }
    },
    dateFormat (classes, date) {
      const newClasses = classes;
      if (!newClasses.disabled) {
        if (this.isSelectedStartDate && this.selectedStartDate) {
          newClasses.disabled = date.getTime() < this.selectedStartDate || date.getTime() > new Date();
        } else {
          newClasses.disabled = date.getTime() > new Date();
        }
      }
      return newClasses;
    },
    setStartDateSelection(date) {
      if (date) {
        this.isSelectedStartDate = true;
        this.selectedStartDate = date;
      }
    },
    setEndDateSelection(date) {
      if (date) {
        this.isSelectedEndDate = true;
        this.selectedEndDate = date;
      }
    },
  },
  computed: {
    ...mapGetters({
      satisfactionFormData: 'satisfaction/satisfactionFormData',
      satisfactionSummaryData: 'satisfaction/satisfactionSummaryData',
      satisfactionFormWithFilterData: 'satisfaction/satisfactionFormWithFilterData',
    }),
    // surveyedStat() {
    //   if (this.satisfactionSummaryData && this.satisfactionSummaryData.surveyed_stat) {
    //     const statNameMap = {
    //       very_satisfied: 'Excellent (5)',
    //       satisfied: 'Good (4)',
    //       ok: 'Fair (3)',
    //       dissatisfied: 'Poor (2)',
    //       very_dissatisfied: 'Very poor (1)',
    //     };

    //     let convertNameStat = {};
    //     for (const key in this.satisfactionSummaryData.surveyed_stat) {
    //       if (statNameMap[key]) {
    //         convertNameStat = {
    //           ...convertNameStat,
    //           [statNameMap[key]]: this.satisfactionSummaryData.surveyed_stat[key],
    //         };
    //       }
    //     }
    //     return convertNameStat;
    //   }
    //   return {};
    // },
    // channelStat() {
    //   if (this.satisfactionSummaryData && this.satisfactionSummaryData.channel_stat) {
    //     return Object.keys(this.satisfactionSummaryData.channel_stat);
    //   }
    //   return [];
    // },
    surveyedStat() {
      if (this.summaryWithFilter && this.summaryWithFilter.surveyed_stat) {
        const statNameMap = {
          very_satisfied: 'Excellent (5)',
          satisfied: 'Good (4)',
          ok: 'Fair (3)',
          dissatisfied: 'Poor (2)',
          very_dissatisfied: 'Very poor (1)',
        };

        let convertNameStat = {};
        for (const key in this.summaryWithFilter.surveyed_stat) {
          if (statNameMap[key]) {
            convertNameStat = {
              ...convertNameStat,
              [statNameMap[key]]: this.summaryWithFilter.surveyed_stat[key],
            };
          }
        }
        return convertNameStat;
      }
      return {};
    },
    channelStat() {
      if (this.channel && this.channel.length) {
        return this.channel;
      }
      return [];
      // if (this.summaryWithFilter && this.summaryWithFilter.channel_stat) {
      //   return Object.keys(this.summaryWithFilter.channel_stat);
      // }
      // return [];
    },
    summaryData() {
      if (this.summaryWithFilter) {
        return this.summaryWithFilter;
      }
      return [];
    },

  },
};
</script>
<style lang="scss" scoped>
.satisfaction {
  display: block;
  overflow-y: auto;
  overflow-x: hidden;
  .head-row {
    margin-bottom: 15px;
    .head-title {
      font-size: 1.25rem;
      line-height: 2rem;
      font-weight: 500;
      display: flex;
      .icon {
        margin-right: 0.5rem;
        display: inline-block;
        svg {
          vertical-align: 0;
          height: 1rem;
        }
      }
    }
    .head-subtitle {
      font-size: 0.9rem;
      font-weight: 300;
      line-height: 2.2rem;
    }
  }
  .satisfaction-wrapper {
    padding: 15px;
    .head-reviews {
      margin-top: 15px;
      margin-bottom: 15px;
      .head-reviews-title {
        font-size: 1.3rem;
        line-height: 2rem;
        font-weight: 500;
        display: flex;
      }
    }
    .reviews-filter {
        margin-top: 15px;
        margin-bottom: 15px;
        justify-content: space-between;
        margin-right: 2px;
        margin-left: 2px;

        .select {
          vertical-align: middle;
        }

        .reportrange-text {
          line-height: 0%;
        }

        .reviews-filter-left {
          .filter-row {
            display: flex;
            align-items: center;
          }

          .reviews-filter-left-text {
            font-weight: 500;
          }
        }

        @media only screen and (max-width: 500px) {
          .reviews-filter-left {
            text-align: center;
          }
        }

        .reviews-filter-right {
          margin-right: 8px;
          .reviews-filter-right-export {
            margin-left: 0.5rem;
          }
        }

        .select-height {
          height: 35.69px;
          text-transform: capitalize;
        }

        // @media only screen and (max-width: 768px) {
        //   .filter-export {
        //     justify-content: flex-start;
        //     padding-left: 0.7rem;
        //     padding-right: 1rem;
        //   }
        // }
    }

    @media only screen and (max-width: 1104px) {
      .reviews-filter {
        justify-content: center;
      }
    }

    .stat-card {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      min-height: 125px;
      .card-header {
        font-size: 0.9rem;
        padding-bottom: 0;
      }
      .custom-card-bar-header {
          margin-bottom: 2.3rem;
        //   margin-bottom: 1.67rem;
      }
      .card-body {

        padding-bottom: 1rem;
        .ratings-averages {
            .ratings-averages-display {
                line-height: 43px;
                font-size: 50px;
                font-weight: 700;
                letter-spacing: -.07em;
                color: #4c4c50;
                margin-right: 3px;
            }
        }

        .ratings-star {
          .badge {
            font-size: 100% !important;
          }
        }

        .total-user,
        .user-rated {
            text-align: right;
            color: #636366;
            font-size: 14px;
            line-height: 1.38462;
            font-weight: 400;
            letter-spacing: -.005em;
        }

       .ratings-bar-body {
            .ratings-bar-display-name {
                text-align: end;
            }
            .ratings-bar-display-count {
                font-size: 1rem;
                text-align: start;
            }
            @media only screen and (max-width: 575px) {
                .ratings-bar-display-name {
                    text-align: start;
                    margin-top: 2px;
                }
                .ratings-bar-display-count {
                    display: none;
                }
            }
            @media only screen and (max-width: 1300px) and (min-width: 765px) {
                .ratings-bar-display-name {
                    text-align: end;
                    margin-top: 2px;
                    white-space: nowrap;
                    width: 50px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }

        }

      }

    }

    .reviews-wrapper {
        .reviews {
            margin-bottom: 20px;
            min-height: 550px;
            .card-reviews {
                height: 300px;
                max-height: 100%;
                border-radius: 0.3rem;
                .line-clamp {
                    display: -webkit-box;
                    // -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                    // overflow: hidden;
                    overflow-x: auto;
                }

                .preset-comments {
                  display: flex;
                  flex-wrap: wrap ;
                  .preset-comment {
                    color: rgba(0,0,0,.4);
                    border: 1px solid rgba(0,0,0,.4);
                    border-radius: .9375rem;
                    padding: .15rem .625rem;
                    cursor: default;
                    text-overflow: ellipsis;
                    word-break: break-word;
                    max-width: 100%;
                    margin-bottom: .3125rem;
                  }
                  .preset-comment:not(:last-child) {
                      margin-right: .525rem;
                  }
                }

                .card-content {
                  height: 300px;
                }

                .card-reviews-footer {
                  font-size: 12px;
                  padding: 0.25rem;
                  background-color: rgba(0,0,0,.02);
                  border-top: 1px solid rgba(0,0,0,.125);
                }
            }
        }
        .reviews-not-found {
            .reviews-not-found-text {
                justify-content: center;
                align-items: center;
                min-height: 200px;
                font-size: 1rem;
            }
        }
    }

    .footer-pagination {
        justify-content: center;
    }
  }

  div .reportrange-text {
    line-height: -1rem;
  }

}

</style>
